import React__default, { useState, useEffect } from 'react';
import cn from 'classnames';
import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { useModal } from '../Modal/index.js';
import styles from 'ui-components/Lightbox.scss';

var _excluded = ["open", "setOpen", "className", "onClose", "onOpen", "variant", "noClose", "children"];
var Lightbox = function Lightbox(_ref) {
  var _cn, _cn2, _cn3;
  var open = _ref.open,
    setOpen = _ref.setOpen,
    className = _ref.className,
    onClose = _ref.onClose,
    onOpen = _ref.onOpen,
    variant = _ref.variant,
    noClose = _ref.noClose,
    children = _ref.children,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var _useState = useState(false),
    isEntering = _useState[0],
    setEnter = _useState[1];
  var _useState2 = useState(false),
    isLeaving = _useState2[0],
    setLeave = _useState2[1];
  var _useState3 = useState(false),
    openLocal = _useState3[0],
    setOpenLocal = _useState3[1];
  var setOpenIfReady = function setOpenIfReady(x) {
    if (!isEntering && !isLeaving) {
      setOpen(x);
    }
  };
  var setIsOpen = function setIsOpen(v) {
    if (!isEntering && !isLeaving) {
      if (v) {
        setOpenLocal(true);
        setEnter(true);
        setTimeout(function () {
          setEnter(false);
          if (typeof onOpen === "function") {
            onOpen();
          }
        }, 500);
      } else {
        setLeave(true);
        setTimeout(function () {
          setLeave(false);
          setOpenLocal(false);
          if (typeof onClose === "function") {
            onClose();
          }
        }, 500);
      }
    }
  };
  useEffect(function () {
    setIsOpen(open);
  }, [open]);
  var _useModal = useModal(openLocal, setOpenIfReady),
    Modal = _useModal.Modal;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Modal, {
    noClose: noClose
  }, /*#__PURE__*/React__default.createElement("div", {
    className: cn(styles.wrapper, (_cn = {}, _cn[styles[variant]] = Boolean(variant), _cn), (_cn2 = {}, _cn2[styles.enter] = isEntering, _cn2), (_cn3 = {}, _cn3[styles.leave] = isLeaving, _cn3))
  }, /*#__PURE__*/React__default.createElement("div", _extends({}, props, {
    className: cn(styles.block, className)
  }), children), /*#__PURE__*/React__default.createElement("div", {
    className: styles.overlay,
    onClick: function onClick() {
      setOpenIfReady(false);
    }
  }))));
};

export { Lightbox };
//# sourceMappingURL=index.js.map
